import TimeAgo from 'javascript-time-ago';
import sq from 'javascript-time-ago/locale/sq.json';
import en from 'javascript-time-ago/locale/en.json';
TimeAgo.addLocale(sq);
TimeAgo.addLocale(en);
const lngcode = window.earthquakeconfig && window.earthquakeconfig.lngcode ? window.earthquakeconfig.lngcode : 'sq';
const timeAgo = new TimeAgo(lngcode);
//console.log(window.earthquakeconfig);
export default timeAgo;
